module.exports = __webpack_public_path__ + "img/pickUpChiringuito.d7b0afeb.svg";